import { axiosInstance } from "./api";

export const getSupplies = async (props) => {
  const params = {
    ...props,
    "pagination[count]": props.paginationCount,
    "pagination[offset]": props.paginationOffset,
  };

  const res = await axiosInstance.get("/supply.get", { params });
  return res.data;
};

export const getSupplyCart = async () => {
  const res = await axiosInstance.get("/supply.getCart");
  return res.data;
};

export const getSupplyOne = async (id) => {
  const params = {
    id,
  };
  const res = await axiosInstance.get("/supply.getOne", { params });
  return res.data;
};

export const getSupplyOne1 = async (id) => {
  const res = await axiosInstance.get(`/api/v2/supply/${id}`);
  return res.data;
};

export const getSupplyProducts = async (id) => {
  const res = await axiosInstance.get(`/api/v2/supply/${id}/products`);
  return res.data;
};

export const uploadSupplyProductDocuments = async (supplyId, productId, files) => {
  const formData = new FormData();
  files.forEach((file) => {
    formData.append("files[]", file);
  });
  const res = await axiosInstance.post(
    `/api/v2/supply/${supplyId}/products/${productId}/uploadDocuments`,
    formData,
    { headers: { "Content-Type": "multipart/form-data" } }
  );
  return res.data;
};

/** Рекламация по строке: сохранение reason и comment в товаре (reclamation на сервере + снимок photos) */
export const saveSupplyProductReclamation = async (supplyId, productId, { reason, comment }) => {
  const res = await axiosInstance.post(
    `/api/v2/supply/${supplyId}/products/${productId}/reclamation`,
    { reason, comment: comment ?? "" }
  );
  return res.data;
};

export const deleteSupplyProductDocument = async (supplyId, productId, key) => {
  const res = await axiosInstance.delete(
    `/api/v2/supply/${supplyId}/products/${productId}/documents`,
    { params: { key } }
  );
  return res.data;
};

export const getSupplyInventoryDetails = async (id) => {
  const res = await axiosInstance.get(`/api/v2/supply/${id}/inventoryDetails`);
  return res.data;
};

export const getSupplyByNumber = async (number) => {
  const res = await axiosInstance.get(`/api/v2/supply/number/${number}`);
  return res.data;
};

export const createSupplyOld = async (props) => {
  const res = await axiosInstance.post("/supply.create", props);
  return res.data;
};

export const createSupply = async (props) => {
  const res = await axiosInstance.post("/api/v2/supply", props);
  return res.data;
};

export const updateSupply = async (props) => {
  const res = await axiosInstance.post("/supply.update", props);
  return res.data;
};

export const getSupplyStatuses = async () => {
  const res = await axiosInstance.get("/supply.getStatuses");
  return res.data;
};

export const setSupplyStatus = async (props) => {
  const res = await axiosInstance.post("/supply.setStatus", props);
  return res.data;
};

export const addSupplyProduct = async (props) => {
  const res = await axiosInstance.post("/supply.addProduct", props);
  return res.data;
};

export const updateSupplyProduct = async (props) => {
  const res = await axiosInstance.post("/supply.updateProduct", props);
  return res.data;
};

export const removeSupplyProducts = async (props) => {
  const res = await axiosInstance.post("/supply.removeProducts", props);
  return res.data;
};

export const updateSupplyProductsWarehuse = async (props) => {
  const res = await axiosInstance.post("/supply.updateWarehouses", props);
  return res.data;
};

export const supplyFileImportUpload = async (props) => {
  const res = await axiosInstance.post("/supply.fileUpload", props);
  return res.data;
};

export const supplyFileImportUpdate = async (props) => {
  const res = await axiosInstance.post("/supply.fileUploadUpdate", props);
  return res.data;
};

export const getSupplyLayoutSheet = async (props) => {
  const res = await axiosInstance.post("/supply.getLayoutSheet", props, {
    responseType: "blob",
  });
  return res.data;
};

export const carryOutSupply = async (props) => {
  const res = await axiosInstance.post("/supply.carryOut", props);
  return res.data;
};

export const getSupplyToExcel = async (props) => {
  const res = await axiosInstance.post("/supply.getToExcel", props, {
    responseType: "blob",
  });
  return res.data;
};

export const exportFilesForTsd = async (props) => {
  const res = await axiosInstance.post("/supply.exportFilesForTsd", props);
  return res.data;
};

export const sendReport = async (props) => {
  const res = await axiosInstance.post("/supply.sendReport", props);
  return res.data;
};

export const getDocFromDiadoc = async (params) => {
  const res = await axiosInstance.get("/supply.getDocFromDiadoc", { params });
  return res.data;
};

export const getDraftFromDiadoc = async (params) => {
  const res = await axiosInstance.get("/supply.getDraftFromDiadoc", { params });
  return res.data;
};

export const getOpenedOrders = async (article) => {
  const params = {
    article
  };
  const res = await axiosInstance.get("/orders.getOpenedByArticle", { params });
  return res.data;
};

export const getAcceptanceActs = async (props) => {
  const params = {
    ...props,
    count: props.paginationCount,
    offset: props.paginationOffset,
  };

  const res = await axiosInstance.get("/api/v2/acceptanceAct", { params });
  return res.data;
};

export const getAcceptanceActOne = async (id) => {
  const res = await axiosInstance.get(`/api/v2/acceptanceAct/${id}`);
  return res.data;
};

export const createAcceptanceAct = async (props) => {
  const res = await axiosInstance.post("/api/v2/acceptanceAct", props);
  return res.data;
};

export const updateAcceptanceAct = async (props) => {
  const { id, ...data } = props;
  const res = await axiosInstance.patch(`/api/v2/acceptanceAct/${id}`, data);
  return res.data;
};

export const removeAcceptanceActProduct = async (props) => {
  const res = await axiosInstance.post("/api/v2/acceptanceAct/removeProduct", props);
  return res.data;
};

export const carryOutAcceptanceAct = async (props) => {
  const res = await axiosInstance.post("/api/v2/acceptanceAct/carryOut", props);
  return res.data;
};

export const importAcceptanceAct = async (props) => {
  const res = await axiosInstance.post("/api/v2/acceptanceAct/import", props);
  return res.data;
};

export const getAcceptanceActLayoutSheet = async ({ id }) => {
  const res = await axiosInstance.get(
    `/api/v2/acceptanceAct/${id}/layoutSheet`,
    { responseType: "blob" }
  );
  return res.data;
};

export const getCountry = async (code) => {
  const params = {
    code,
  };
  const res = await axiosInstance.get("/country.get", { params });
  return res.data;
};

export const getEnteringBalances = async ({
  paginationCount,
  paginationOffset,
  search,
  number,
  admin,
}) => {
  const params = {
    count: paginationCount,
    offset: paginationOffset,
    search,
    number,
    admin,
  };

  const res = await axiosInstance.get("/api/v2/enteringBalance", { params });
  return res.data;
};

export const getEnteringBalanceOne = async (id) => {
  const res = await axiosInstance.get(`/api/v2/enteringBalance/${id}`);
  return res.data;
};

export const createEnteringBalance = async (props) => {
  const res = await axiosInstance.post("/api/v2/enteringBalance", props);
  return res.data;
};

export const updateEnteringBalance = async (props) => {
  const { id, ...data } = props;
  const res = await axiosInstance.patch(`/api/v2/enteringBalance/${id}`, data);
  return res.data;
};

export const updateEnteringBalanceProduct = async (props) => {
  const res = await axiosInstance.post(
    "/api/v2/enteringBalance/updateProduct",
    props
  );
  return res.data;
};

export const carryOutEnteringBalance = async (props) => {
  const res = await axiosInstance.post("/api/v2/enteringBalance/carryOut", props);
  return res.data;
};

export const addEnteringBalanceProduct = async (props) => {
  const res = await axiosInstance.post("/api/v2/enteringBalance/addProduct", props);
  return res.data;
};

export const removeEnteringBalanceProduct = async (props) => {
  const res = await axiosInstance.post("/api/v2/enteringBalance/removeProduct", props);
  return res.data;
};

export const getCorrOrders = async (props) => {
  const params = {
    ...props,
    count: props.paginationCount,
    offset: props.paginationOffset,
  };

  const res = await axiosInstance.get("/api/v2/corrOrder", { params });
  return res.data;
};

export const getCorrOrderOne = async (id) => {
  const res = await axiosInstance.get(`/api/v2/corrOrder/${id}`);
  return res.data;
};

export const getOrderForCorr = async (number) => {
  const res = await axiosInstance.get("/api/v2/corrOrder/order", {
    params: { number },
  });
  return res.data;
};

export const createCorrOrder = async (props) => {
  const res = await axiosInstance.post("/api/v2/corrOrder", props);
  return res.data;
};

export const updateCorrOrder = async (props) => {
  const { id, ...data } = props;
  const res = await axiosInstance.patch(`/api/v2/corrOrder/${id}`, data);
  return res.data;
};

export const carryOutCorrOrder = async (props) => {
  const res = await axiosInstance.post("/api/v2/corrOrder/carryOut", props);
  return res.data;
};

export const downloadCorrOrder = async (props) => {
  const res = await axiosInstance.post("/api/v2/corrOrder/download", props, {
    responseType: "blob",
  });
  return res.data;
};

export const getCorrOrderListToExcel = async (props) => {
  const res = await axiosInstance.post(
    "/api/v2/corrOrder/downloadList",
    props,
    {
      responseType: "blob",
    }
  );
  return res.data;
};

export const sendCorrOrderToDiadoc = async (props) => {
  const res = await axiosInstance.post("/api/v2/corrOrder/sendToDiadoc", props);
  return res.data;
};

export const getReturnsToProvider = async (props) => {
  const params = {
    ...props,
    count: props.paginationCount,
    offset: props.paginationOffset,
  };

  const res = await axiosInstance.get("/api/v2/returnToProvider", { params });
  return res.data;
};

export const getReturnToProviderOne = async (id) => {
  const res = await axiosInstance.get(`/api/v2/returnToProvider/${id}`);
  return res.data;
};

export const getReturnsToProviderStatuses = async () => {
  const res = await axiosInstance.get("/api/v2/returnToProvider/statuses");
  return res.data;
};

export const createReturnToProvider = async (props) => {
  const res = await axiosInstance.post("/api/v2/returnToProvider", props);
  return res.data;
};

export const updateReturnToProvider = async (props) => {
  const { id, ...data } = props;
  const res = await axiosInstance.patch(`/api/v2/returnToProvider/${id}`, data);
  return res.data;
};

export const carryOutReturnToProvider = async (props) => {
  const res = await axiosInstance.post("/api/v2/returnToProvider/carryOut", props);
  return res.data;
};

export const updateReturnToProviderProduct = async (props) => {
  const res = await axiosInstance.post(
    "/api/v2/returnToProvider/updateProduct",
    props
  );
  return res.data;
};

export const removeReturnToProviderProduct = async (params) => {
  const res = await axiosInstance.post("/api/v2/returnToProvider/removeProduct", params);
  return res.data;
};

export const returnToProviderUploadDocument = async (props) => {
  const res = await axiosInstance.post(
    "/api/v2/returnToProvider/uploadDocument",
    props
  );
  return res.data;
};

export const returnToProviderRemoveDocument = async (params) => {
  const res = await axiosInstance.delete("/api/v2/returnToProvider/removeDocument", { params });
  return res.data;
};

export const sendReturnToProviderToDiadoc = async (props) => {
  const res = await axiosInstance.post("/api/v2/returnToProvider/sendToDiadoc", props);
  return res.data;
};

export const getUpd = async (props) => {
  const res = await axiosInstance.post("/api/v2/returnToProvider/getUpd", props, {
    responseType: "blob",
  });
  return res.data;
};

export const getReturnsToProviderToExcel = async (props) => {
  const res = await axiosInstance.post(
    "/api/v2/returnToProvider/downloadList",
    props,
    {
      responseType: "blob",
    }
  );
  return res.data;
};

export const createCustomsDeclaration = async (props) => {
  const res = await axiosInstance.post("/customsDelcarations.create", props);
  return res.data;
};

export const removeCustomsDeclaration = async (props) => {
  const res = await axiosInstance.post("/customsDelcarations.remove", props);
  return res.data;
};

export const createAdditionalExpence = async (props) => {
  const res = await axiosInstance.post("/additionalExpences.create", props);
  return res.data;
};

export const removeAdditionalExpence = async (props) => {
  const res = await axiosInstance.post("/additionalExpences.remove", props);
  return res.data;
};

export const getOrdersToProvider = async (props) => {
  const params = {
    ...props,
    "pagination[count]": props.paginationCount,
    "pagination[offset]": props.paginationOffset,
  };

  const res = await axiosInstance.get("/ordersToProvider.get", { params });
  return res.data;
};

export const getOrderToProviderOne = async (id) => {
  const params = {
    id,
  };
  const res = await axiosInstance.get("/ordersToProvider.getOne", { params });
  return res.data;
};

export const createOrderToProvider = async (props) => {
  const res = await axiosInstance.post("/ordersToProvider.create", props);
  return res.data;
};

export const updateOrderToProvider = async (props) => {
  const res = await axiosInstance.post("/ordersToProvider.update", props);
  return res.data;
};

export const getOrderToProviderStatuses = async () => {
  const res = await axiosInstance.get("/ordersToProvider.getStatuses");
  return res.data;
};

export const setOrderToProviderStatus = async (props) => {
  const res = await axiosInstance.post("/ordersToProvider.statusUpdate", props);
  return res.data;
};

export const orderToProviderFileUpload = async (props) => {
  const res = await axiosInstance.post("/ordersToProvider.fileUpload", props);
  return res.data;
};

export const orderToProviderUploadDocument = async (props) => {
  const res = await axiosInstance.post(
    "/ordersToProvider.uploadDocument",
    props
  );
  return res.data;
};

export const orderToProviderSetDateArrival = async (props) => {
  const res = await axiosInstance.post(
    "/ordersToProvider.setDateArrival",
    props
  );
  return res.data;
};

export const getOrderToProviderDocument = async (props) => {
  const res = await axiosInstance.post("/ordersToProvider.getDocument", props, {
    responseType: "blob",
  });
  return res.data;
};

export const updateOrderToProviderProduct = async (props) => {
  const res = await axiosInstance.post(
    "/ordersToProvider.updateProduct",
    props
  );
  return res.data;
};

export const addOrderToProviderProduct = async (props) => {
  const res = await axiosInstance.post("/ordersToProvider.addProduct", props);
  return res.data;
};

export const removeOrderToProviderProducts = async (props) => {
  const res = await axiosInstance.post(
    "/ordersToProvider.removeProduct",
    props
  );
  return res.data;
};

export const orderToProviderSelectionProducts = async (params) => {
  const res = await axiosInstance.get("/ordersToProvider.selectionProducts", { params });
  return res.data;
};

export const getOrderToProviderExcel = async (props) => {
  const res = await axiosInstance.post(
    "/ordersToProvider.getToExcel",
    props,
    {
      responseType: "blob",
    }
  );
  return res.data;
};

export const getPriceLists = async (props) => {
  const params = {
    ...props,
    "pagination[count]": props.paginationCount,
    "pagination[offset]": props.paginationOffset,
  };

  const res = await axiosInstance.get("/api/v2/priceList/get", { params });
  return res.data;
};

export const getPriceListOne = async (id) => {
  const params = {
    id,
  };
  const res = await axiosInstance.get("/api/v2/priceList/getOne", { params });
  return res.data;
};

export const createPriceList = async (props) => {
  const res = await axiosInstance.post("/api/v2/priceList/create", props);
  return res.data;
};

export const updatePriceList = async (props) => {
  const res = await axiosInstance.post("/api/v2/priceList/update", props);
  return res.data;
};

export const priceListSuggestion = async (search) => {
  const params = {
    search,
  };
  const res = await axiosInstance.get("/api/v2/priceList/suggestion", { params });
  return res.data;
};

export const getReturnRequests = async (props) => {
  const res = await axiosInstance.get("/api/v2/returnRequest", { params: props });
  return res.data;
};

export const getReturnRequestOne = async (id) => {
  const res = await axiosInstance.get(`/api/v2/returnRequest/${id}`);
  return res.data;
};

export const updateReturnRequestOne = async (id, props) => {
  const res = await axiosInstance.patch(`/api/v2/returnRequest/${id}`, props);
  return res.data;
};

export const createReturnRequest = async (props) => {
  const res = await axiosInstance.post("/api/v2/returnRequest", props);
  return res.data;
};

export const getReasonForReturn = async (props) => {
  const res = await axiosInstance.get("/api/v2/returnRequest/reasonForReturn", { params: props });
  return res.data;
};

export const updateReturnRequestProduct = async (id, props) => {
  const res = await axiosInstance.patch(`/api/v2/ReturnRequestProduct/${id}`, props);
  return res.data;
};

export const removeReturnRequestProducts = async (params) => {
  const res = await axiosInstance.delete(`/api/v2/ReturnRequestProduct`, { params });
  return res.data;
};

export const uploadFiles = async (id, formData) => {
  const res = await axiosInstance.post(`/api/v2/ReturnRequestProduct/${id}/files`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
};

export const createReturnToProviderFromReturnRequest = async (props) => {
  const res = await axiosInstance.post(`api/v2/returnRequest/${props.id}/provider`, props);
  return res.data;
}

export const getReturnRequestStatuses = async () => {
  const res = await axiosInstance.get("/api/v2/returnToProvider/statuses");
  return res.data;
};